import type { AppLanguage, TranslationKey } from "./types";

export const LANGUAGE_OPTIONS: ReadonlyArray<{
  code: AppLanguage;
  label: string;
}> = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
];

export const TRANSLATIONS: Readonly<
  Record<AppLanguage, Readonly<Record<TranslationKey, string>>>
> = {
  es: {
    "business.country": "País de operación",
    "business.language": "Idioma de la aplicación",
    "business.currencyInfo":
      "{{currency}} ({{code}}) · unidad física mínima {{unit}}",
    "business.languageRecommendation":
      "Idioma regional recomendado: {{language}}.",
    "business.configurationSaved": "Configuración guardada correctamente",
    "business.configurationSaveFailed": "No se pudo guardar la configuración",
    "registration.title": "Crear cuenta",
    "registration.subtitle": "Comienza con 7 días de prueba gratis",
    "registration.businessName": "Nombre del negocio",
    "registration.email": "Correo electrónico",
    "registration.password": "Contraseña",
    "registration.businessType": "Tipo de negocio",
    "registration.customBusinessType": "Especifica el tipo de negocio",
    "registration.document": "Documento del negocio",
    "registration.phone": "Teléfono",
    "registration.city": "Ciudad",
    "registration.countryCurrency": "País y moneda",
    "registration.language": "Idioma",
    "registration.submit": "Crear cuenta gratis",
    "registration.submitting": "Creando cuenta...",
    "registration.required": "Por favor completa todos los campos",
    "registration.customTypeRequired": "Especifica el tipo de negocio",
    "registration.passwordMinimum":
      "La contraseña debe tener al menos 6 caracteres",
    "registration.success": "Registro exitoso. Tienes 7 días de prueba gratis.",
    "registration.failed": "Error al registrarse",
    "registration.socialUnavailable":
      "Registro con {{provider}} disponible próximamente",
  },
  en: {
    "business.country": "Operating country",
    "business.language": "Application language",
    "business.currencyInfo":
      "{{currency}} ({{code}}) · smallest physical unit {{unit}}",
    "business.languageRecommendation":
      "Recommended regional language: {{language}}.",
    "business.configurationSaved": "Configuration saved successfully",
    "business.configurationSaveFailed": "The configuration could not be saved",
    "registration.title": "Create account",
    "registration.subtitle": "Start with a 7-day free trial",
    "registration.businessName": "Business name",
    "registration.email": "Email address",
    "registration.password": "Password",
    "registration.businessType": "Business type",
    "registration.customBusinessType": "Specify the business type",
    "registration.document": "Business document",
    "registration.phone": "Phone",
    "registration.city": "City",
    "registration.countryCurrency": "Country and currency",
    "registration.language": "Language",
    "registration.submit": "Create free account",
    "registration.submitting": "Creating account...",
    "registration.required": "Please complete all fields",
    "registration.customTypeRequired": "Specify the business type",
    "registration.passwordMinimum": "Password must be at least 6 characters",
    "registration.success":
      "Registration successful. You have a 7-day free trial.",
    "registration.failed": "Could not register",
    "registration.socialUnavailable":
      "{{provider}} registration will be available soon",
  },
  pt: {
    "business.country": "País de operação",
    "business.language": "Idioma do aplicativo",
    "business.currencyInfo":
      "{{currency}} ({{code}}) · menor unidade física {{unit}}",
    "business.languageRecommendation":
      "Idioma regional recomendado: {{language}}.",
    "business.configurationSaved": "Configuração salva com sucesso",
    "business.configurationSaveFailed":
      "Não foi possível salvar a configuração",
    "registration.title": "Criar conta",
    "registration.subtitle": "Comece com 7 dias de teste grátis",
    "registration.businessName": "Nome do negócio",
    "registration.email": "E-mail",
    "registration.password": "Senha",
    "registration.businessType": "Tipo de negócio",
    "registration.customBusinessType": "Especifique o tipo de negócio",
    "registration.document": "Documento do negócio",
    "registration.phone": "Telefone",
    "registration.city": "Cidade",
    "registration.countryCurrency": "País e moeda",
    "registration.language": "Idioma",
    "registration.submit": "Criar conta grátis",
    "registration.submitting": "Criando conta...",
    "registration.required": "Preencha todos os campos",
    "registration.customTypeRequired": "Especifique o tipo de negócio",
    "registration.passwordMinimum": "A senha deve ter pelo menos 6 caracteres",
    "registration.success":
      "Registro concluído. Você tem 7 dias de teste grátis.",
    "registration.failed": "Não foi possível registrar",
    "registration.socialUnavailable":
      "O registro com {{provider}} estará disponível em breve",
  },
};
